export const WHATS_NEW = 'What’s New'
export const RELEASE_NOTES = 'Release Notes'

export const CATEGORIES = [
  // note the difference `’` in chapter ame and `'` in children name
  { name: WHATS_NEW, children: ["What's New"] },
  { name: RELEASE_NOTES, children: [RELEASE_NOTES] },
  { name: 'Technical Specifications', children: ['Data Sheets'] },
  {
    name: 'User Guides',
    children: [
      'Getting Started',
      'Quick Start Guides',
      "Readme's",
      'Product Guides',
      'Admin Guides',
      'API Guide',
    ],
  },
  { name: 'How-Tos', children: ['Configurations', 'Troubleshooting', 'FAQs'] },
  { name: 'Design and Deployment Guides', children: [] },
  { name: 'Readme', children: [] },
  {
    name: 'Miscellaneous',
    children: [
      'End-of-Life Notices',
      'VPAT',
      'License Agreement',
      'LiveAction LiveNX MIB',
      'LiveAction LiveWire MIB',
    ],
  },
]

// LiveWire landing page
export const CATEGORIES_LIVEWIRE = [
  { name: WHATS_NEW, children: ["What's New"] },
  { name: RELEASE_NOTES, children: [RELEASE_NOTES] },
  { name: 'Appliance Technical Datasheets', children: [] },
  { name: 'Quick Start Guides', children: [] },
  { name: 'User Guides', children: [] },
  { name: 'How-Tos, FAQ’s and Troubleshooting', children: [] },
]
